import {Component, OnChanges, OnInit, ViewChild} from '@angular/core';
import {AbstractFields} from '../_abstract';
import {WizardInterfaces} from '../../wizard.namespace';
import {NewEquipmentModalComponent} from './modal/equipment-modal.component';
import {EquipmentDataService} from './equipment-data.service';
import {EquipmentCardInterfaces} from '@namespaces/equipment.namespace';
import {EquipmentService} from '../../services/wizard-form-groups-services/nested-forms/equipment.service';
import {EquipmentGroupPreview} from './equipment-group-preview/equipment-group-preview';
import {ModelsInterfaces} from '@namespaces/models.namespace';
import {MethodsProvider} from '@providers/methods/methods.provider';

@Component({
    selector: 'app-equipment-step',
    providers: [
        EquipmentDataService
    ],
    templateUrl: './equipment.component.html'
})

export class EquipmentComponent extends AbstractFields implements OnChanges, OnInit {

    @ViewChild(NewEquipmentModalComponent) modal: NewEquipmentModalComponent;

    groups: EquipmentGroupPreview[] = [];

    attestation: WizardInterfaces.AttestationValue;

    hasNotModerated = false;

    method: ModelsInterfaces.Method;

    constructor(
        private equipmentService: EquipmentService,
        private equipmentDataService: EquipmentDataService,
        private methodsProvider: MethodsProvider,
    ) {
        super();
    }

    ngOnInit() {
        super.ngOnInit();

        this.subs.push(
            this.equipmentService.refreshValue$.subscribe(() => {
                this.updateGroups();
            })
        );
    }

    showApparatusModal(group: WizardInterfaces.ApparatusStepGroup) {
        this.equipmentDataService.group$.next(group);
        this.modal.search();
    }

    editApparatusCard(card: EquipmentCardInterfaces.Card.ItemView, group: WizardInterfaces.ApparatusStepGroup) {
        this.equipmentDataService.group$.next(group);
        this.modal.edit(card);
    }

    update(data: EquipmentCardInterfaces.Card.ItemView) {
        const isReference = this.form.value.is_reference;

        try {
            const methodIds: number[] = data.apparatus.methods.map(item => item.id);
            methodIds.forEach(id => {
                this.equipmentService.updateValue(id, isReference);
            });
        } catch (e) {
            const methodId = this.form.value.id;
            this.equipmentService.updateValue(methodId, isReference);
        }
    }

    ngOnChanges() {
        this.updateGroups();
    }

    private updateGroups() {
        const methodId = this.form.value.id;
        const isReference = this.form.value.is_reference;
        const data = this.equipmentService.getStorageData(methodId, isReference);
        const groups = data.groups || [];

        this.method = this.methodsProvider.getById(methodId);
        this.attestation = data.attestation || null;
        this.hasNotModerated = Boolean(data.has_not_moderated);

        this.groups = this.getSortedGroups(groups);

        if (!this.attestation) {
            return;
        }

        this.equipmentDataService.methodId$.next(methodId);
        this.equipmentDataService.methodTitle$.next(this.attestation.key);
        this.equipmentDataService.attestation$.next(this.attestation);
        this.equipmentDataService.isReference$.next(isReference);
    }

    /**
     * Сортировка групп оборудования для отображения
     * @param groups
     */
    private getSortedGroups(groups: WizardInterfaces.ApparatusStepGroup[] = []): EquipmentGroupPreview[] {
        return groups.sort((a, b) => {
            /**
             * Статичная группа "Датчики и приспособления" всегда последняя
             */
            if (+a.id === 999999) {
                return 1;
            }

            /**
             * Обязательные группы идут выше не обязательных. И те и другие в пределах своей обязательности сортированы по имени
             */
            if (a.required === b.required) {
                return a.title <= b.title ? -1 : 1;
            } else {
                return a.required ? -1 : 1;
            }
        }).map(group => new EquipmentGroupPreview(group));
    }
}
